import { GraphCompareResponse } from 'src/api/gen/api'
import { formatDateExport, spreadBy } from 'src/commons/export/Export'
import { getTranslation } from 'src/commons/i18n'
import { GranularityEnum } from 'src/commons/types'

// Graph GazEmissionPerProviderComponent
export function formatExportEmissionsPerProvider(granularity: GranularityEnum) {
  const { t } = getTranslation()
  return (bucket: GraphCompareResponse) => ({
    [t('kpi.export.Date')]: formatDateExport(bucket.key, granularity),
    ...spreadBy(bucket.compareBy.buckets),
    [t('kpi.export.AverageForAllProviders')]: bucket.average,
  })
}

// Graph GazEmissionsCompareToAlternateVehicle
export function formatExportGazEmissionsCompareToAlternateVehicle(granularity: GranularityEnum) {
  const { t } = getTranslation()
  return (bucket: GraphCompareResponse) => ({
    [t('kpi.export.Date')]: formatDateExport(bucket.key, granularity),
    ...spreadBy(bucket.compareBy.buckets),
  })
}
